import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme, alpha } from '@mui/material';

export const buttonTheme: {
    defaultProps?: ComponentsProps['MuiButton'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiButton'];
    variants?: ComponentsVariants['MuiButton'];
} = {
    defaultProps: {
        disableElevation: true,
    },
    variants: [
        {
            props: { variant: 'actions-menu-item' },
            style: ({ theme }: { theme: Theme }) => ({
                width: '100%',
                textAlign: 'left',
                justifyContent: 'flex-start',
                borderRadius: 0,
                '.MuiButton-actions-menu-itemPrimary': {
                    color: theme.palette.secondary.main,
                },
                '.MuiButton-actions-menu-itemError': {
                    color: theme.palette.error.main,
                },
            }),
        } as any,
    ],
    styleOverrides: {
        root: ({ theme }) => ({
            textTransform: 'none',
            boxShadow: 'none',
            whiteSpace: 'nowrap',
            borderRadius: theme.shape.borderRadius * 2,
            '&.Mui-disabled': {
                color: theme.palette.text.disabled,
            },
        }),
        sizeLarge: {
            fontSize: 15,
            lineHeight: '26px',
        },
        sizeMedium: {
            fontSize: 14,
            lineHeight: '24px',
        },
        sizeSmall: {
            fontSize: 13,
            lineHeight: '22px',
        },
        contained: ({ theme }) => ({
            '&.Mui-disabled': {
                backgroundColor: alpha(theme.palette.primary.main, 0.12),
            },
        }),
        text: {
            '&:hover': {
                backgroundColor: 'transparent',
                boxShadow: 'none',
            },
            '&:active': {
                boxShadow: 'none',
                backgroundColor: 'transparent',
            },
        },
        outlined: ({ ownerState, theme }) => {
            const color = theme.palette[ownerState.color ?? 'primary'];

            return {
                border: `1px solid ${color['main']}`,
                color: color['main'],
                ':hover': {
                    borderWidth: 1,
                    backgroundColor: alpha(color['main'], 0.04),
                    border: `1px solid ${color['dark']}`,
                    color: color['dark'],
                    ...(ownerState.color === 'primary' && {
                        color: color['main'],
                        borderColor: theme.palette.primary.main,
                    }),
                },
                ...(ownerState.color === 'primary' && {
                    borderColor: theme.palette.border,
                }),
            };
        },
    },
};
